import React, { useState, useEffect, useContext } from "react";
import {
  Autocomplete,
  TextField,
  Stack,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { useQuery } from "@apollo/client";
//Icons
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EmptyImge from "../../Assets/empty-image.png";
//Srcs
import "../../Style/dialogstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { SELECT_MATERIAL } from "../../Schema/Material";
import SelectMaterailUnit from "../ReqPurchase/SelectMaterailUnit";
export default function ListReqTakeOut({
  handleUpdateList,
  handleDeleteList,
  handleAddList,
  requiredField,
  listTakeOutData,
  officeId,
  editData,
}) {
  const [listMaterialOptions, setMeterialOptions] = useState([]);
  const [checkShiftRefetch, setCheckShiftRefetch] = useState(false);
  const { refetch } = useQuery(SELECT_MATERIAL, {
    variables: {
      isUse: true, 
      groupId: null,
      sectionId: null,
    },
    onCompleted: ({ selectMaterial }) => {
      const Data = selectMaterial?.map((e) => {
        return {
          id: e?._id,
          title: e?.materialKhName,
        };
      });
      setMeterialOptions(Data);
    },
    onError: (error) => {
      // setLoading(true);
      console.log(error?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [checkShiftRefetch]);

  return (
    <Stack direction="column" spacing={1} sx={{ width: "100%" }}>
      <Stack
        direction="row"
        spacing={1}
        mb={1}
        bgcolor="#f5faff"
        paddingX="2px"
        paddingY="5px"
        borderRadius="8px"
      >
        <Typography className="field-title-list" sx={{ width: "10%" }}>
          រូបភាព
        </Typography>
        <Typography className="field-title-list" sx={{ width: "40%" }}>
          ឈ្មោះសម្ភារៈ
        </Typography>
        <Typography className="field-title-list" sx={{ width: "25%" }}>
          ឯកតា
        </Typography>
        <Typography className="field-title-list" sx={{ width: "20%" }}>
          ចំនួន
        </Typography>
        <Stack width="5%" direction="column" justifyContent="center">
          <Box textAlign="center">
            <IconButton onClick={handleAddList}>
              <AddCircleIcon sx={{ color: "#2e3192" }} />
            </IconButton>
          </Box>
        </Stack>
      </Stack>
      {listTakeOutData?.map((e, index) => {
        // console.log("e", e);
        return (
          <Stack direction="row" spacing={1} key={e?.key}>
            <Stack width="10%">
              <img
                style={{
                  borderRadius: "10px",
                  objectFit: "cover",
                  width: "80%",
                }}
                src={
                  e?.listMaterialUnitId?.imageSrc
                    ? e?.listMaterialUnitId?.imageSrc
                    : EmptyImge
                }
              />
            </Stack>
            <Stack width="40%" direction="column" justifyContent="center">
              <Autocomplete
                value={e.materialId}
                options={listMaterialOptions}
                onChange={(event, val) => {
                  setCheckShiftRefetch(true);
                  handleUpdateList(e.key, val, "materialId");
                }}
                getOptionLabel={(option) =>
                  option?.title === undefined ? "ជ្រើសរើស" : option?.title
                }
                isOptionEqualToValue={(option, value) =>
                  option?.value === value?.value
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder={"ជ្រើសរើស"}
                    error={
                      (requiredField && e?.materialId?.id === undefined) ||
                      (requiredField && e?.materialId?.id === "")
                        ? true
                        : false
                    }
                  />
                )}
              />
            </Stack>
            <Stack width="25%" direction="column" justifyContent="center">
              <SelectMaterailUnit
                eachList={e}
                handleUpdateValue={handleUpdateList}
                requiredField={requiredField}
              />
            </Stack>
            <Stack width="20%" direction="column" justifyContent="center">
              <TextField
                className="text-field"
                fullWidth
                size="small"
                type="number"
                placeholder="បរិមាណ"
                onFocus={(e) => e?.target?.select()}
                value={e?.qty}
                onChange={(val) =>
                  handleUpdateList(e.key, val.target.value, "qty")
                }
                error={
                  (requiredField && e?.qty === 0) ||
                  (requiredField && e?.qty < 0)
                }
                inputProps={{
                  min: 0,
                }}
              />
            </Stack>

            <Stack width="5%" direction="column" justifyContent="center">
              <IconButton
                sx={{ width: "40px", height: "40px" }}
                onClick={(event) => handleDeleteList(e.key)}
              >
                <RemoveCircleIcon sx={{ color: "red" }} />
              </IconButton>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
}
